import { Bell, Search } from "lucide-react";
import { SidebarProvider, SidebarTrigger } from "@/shared/ui/sidebar.jsx";
import { Input } from "@/shared/ui/input.jsx";
import { Button } from "@/shared/ui/button.jsx";
import { AppSidebar } from "./AppSidebar.jsx";
import { ImpersonationBanner } from "./ImpersonationBanner.jsx";

/**
 * Moldura do sistema da clínica: barra lateral + cabeçalho + conteúdo.
 *
 * @param {object} props
 * @param {string} props.title
 * @param {string} [props.subtitle]
 * @param {React.ReactNode} [props.actions] botões à direita do cabeçalho
 * @param {React.ReactNode} props.children
 */
export function AppShell({ title, subtitle, actions, children }) {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-background">
        <AppSidebar />

        <div className="flex min-w-0 flex-1 flex-col">
          <ImpersonationBanner />

          <header className="sticky top-0 z-30 flex h-16 items-center gap-3 border-b border-border/60 bg-background/80 px-4 backdrop-blur-xl">
            <SidebarTrigger />

            <div className="hidden min-w-0 flex-col md:flex">
              <h1 className="truncate font-display text-base font-semibold leading-tight">{title}</h1>
              {subtitle && <p className="truncate text-xs text-muted-foreground">{subtitle}</p>}
            </div>

            <div className="relative ml-auto hidden w-72 lg:block">
              <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
              <Input
                placeholder="Buscar leads, conversas..."
                className="h-9 border-transparent bg-muted/40 pl-9 focus-visible:bg-background"
                aria-label="Buscar"
              />
            </div>

            <div className="ml-auto flex items-center gap-2 lg:ml-0">
              {actions}
              <Button variant="ghost" size="icon" className="relative" aria-label="Notificações">
                <Bell className="h-4 w-4" />
                <span className="absolute right-2 top-2 h-1.5 w-1.5 rounded-full bg-primary" />
              </Button>
            </div>
          </header>

          <main className="min-w-0 flex-1">{children}</main>
        </div>
      </div>
    </SidebarProvider>
  );
}
